<template>
  <li>
    {{ task }}
    <button @click="removeTask">Удалить</button>
  </li>
</template>

<script>
export default {
  props: {
    task: String
  },
  methods: {
    removeTask() {
      this.$emit('remove');
    }
  }
};
</script>
